import type { ReactNode } from 'react';
import LanguageSwitcher from '../i18n/LanguageSwitcher';

type SiteHeaderProps = {
  children?: ReactNode;
  hideLangSwitcher?: boolean;
  className?: string;
};

export default function SiteHeader({ children, hideLangSwitcher = false, className = '' }: SiteHeaderProps) {
  return (
    <header className={`site-header${className ? ` ${className}` : ''}`}>
      <div className="site-header__brand">{children}</div>
      <LanguageSwitcher hidden={hideLangSwitcher} />
    </header>
  );
}